import React, { useContext, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useGoogleLogin } from '@react-oauth/google';
import toast from 'react-hot-toast';
import { AuthContext } from '../../context/auth.context';
import { AuthService } from '../../services';
import { Constants } from '../../utils'
import { LoginBG, Logo } from '../../assets/img';
import { PasswordActive, PasswordInactive, GmailIcon } from '../../assets/icons';

const Login = () => {
  const [isVisible, setIsVisible] = useState(false);
  const toggleVisibility = () => setIsVisible(!isVisible);
  const { form, isLoading, isLoadingGmail, loginGmail, onChange, onSubmit } = useForm();

  return (
    <div
      className="max-w-[1440px] h-screen relative mx-auto"
      style={{ backgroundImage: `url(${LoginBG})`, backgroundSize: 'cover', backgroundPositionX: 'center' }}
    >
      <div className="w-[22rem] h-full mx-auto py-4 flex flex-col justify-center items-center">
        <img src={ Logo } className="w-48 object-contain" alt="" />

        <form className="mt-14 mx-auto w-full" onSubmit={onSubmit}>
          <div className="flex items-center gap-x-4 border border-gray3 bg-white rounded-lg h-12 w-full px-4">
            <input
              className="flex-1 outline-none border-none bg-transparent"
              placeholder="Usuario"
              value={form.email}
              onChange={e => onChange(e.target.value,'email')}
            />
          </div>

          <div style={{ height: 20 }} />

          <div className="flex items-center gap-x-4 border border-gray3 bg-white rounded-lg h-12 w-full px-4">
            <input
              type={ isVisible ? "text" : "password" }
              className="flex-1 outline-none border-none bg-transparent"
              placeholder="Contraseña"
              value={form.password}
              onChange={e => onChange(e.target.value,'password')}
            />
            <button className="focus:outline-none" type="button" onClick={toggleVisibility}>
              <img src={isVisible ? PasswordActive : PasswordInactive} className="w-6 h-6" alt="" />
            </button>
          </div>

          <button
            className="mt-8 rounded-lg w-full text-center h-12 bg-blue font-bold text-lg text-white"
            disabled={isLoading}
          >
            <span>Iniciar Sesión</span>
          </button>

          <div className="mt-12 flex flex-row justify-between">
            <Link to="/register">
              <span>Registrar</span>
            </Link>

            <Link to="/recover">
              <span className="text-blue2">Olvidé mi contraseña</span>
            </Link>
          </div>

          <p className="text-center my-6 font-semibold">Iniciar sesión con</p>

          <div className="text-center mb-4">
            {/* <button onClick={this.loginFacebook}>
              <img source={FacebookIcon} style={styles.socialIcon} />
            </button>

            <div style={{ width: 30 }} /> */}

            <button
              type="button"
              className="mt-8 rounded-lg w-full h-12 bg-[#EFEFEF] flex items-center justify-center gap-6 shadow-md"
              onClick={loginGmail}
              disabled={isLoadingGmail}
            >
              <img src={GmailIcon} className="w-12 h-12 object-contain" alt="" />
              <span>Continuar con Google</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

const useForm = () => {
  const { login } = useContext(AuthContext);
  const dispatch = useDispatch();
  const history = useHistory();
  const [form, setForm] = useState({ email: '', password: '' });
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingGmail, setIsLoadingGmail] = useState(false);

  const gmailLogin = useGoogleLogin({
    onSuccess: async tokenResponse => {
      const googleResponse = await fetch('https://www.googleapis.com/oauth2/v3/userinfo',
        { headers: { Authorization: `Bearer ${tokenResponse.access_token}` },
      })

      const user = await googleResponse.json();

      const data = {
        email: user.email,
        google_id: user.sub,
        google: Constants.GOOGLE,
      };

      const session = await AuthService.checkGoogle(data);
      if (session.user) {
        login(session.user?.user);
        dispatch({ type: 'SET_USER', payload: session.user?.user });
        dispatch({ type: 'SET_JWT', payload: session.user?.token });
        history.push('/');

      } else if (session.register) {
        const content = btoa(JSON.stringify(user));
        history.push(`/register/google/${content}`);
      }
    },
    onError: () => toast.error('Ocurrió un error inesperado'),
  });

  const onChange = (value, target) => {
    setForm(s => ({ ...s, [target]: value }));
  }

  const isValidForm = () => {
    const onError = (msg) => {
      toast.error(msg);
      return false;
    }

    if (!form.email)
      return onError('Debe ingresar el correo');

    if (!form.password)
      return onError('Debe ingresar la contraseña');

    return true;
  }

  const submit = async (event) => {
    event.preventDefault();
    if (!isValidForm()) return;
    setIsLoading(true);

    try {
      const session = await AuthService.login(form);
      login(session.user?.user);
      dispatch({ type: 'SET_USER', payload: session.user?.user });
      dispatch({ type: 'SET_JWT', payload: session.user?.token });
      history.push('/');

    } catch (error) {
      // 
    }
    setIsLoading(false);
  }

	const loginGmail = async () => {
		if (isLoadingGmail) return;
    setIsLoadingGmail(true);
    gmailLogin();
	}

  return {
    form,
    isLoading,
    isValidForm,
    loginGmail,
    isLoadingGmail,
    onChange,
    onSubmit: submit,
  };
}

export default Login;